import { events } from "@grindex-common/helpers/events";
import { addListener } from "@grindex-common/helpers/domManipulation";
import SearchKeyword from "@grindex-client/components/Search/Extensions/search-keyword.class";

export default class DateSearch extends SearchKeyword {
	datesExtensionName: string;
	$from: any;
	$to: any;
	constructor($module: HTMLElement, eventManager, dirtyManager, query) {
		super($module, eventManager, dirtyManager, query);
		this.init();
		this.datesExtensionName = "dateSearch";
	}

	override init() {
		this.$from = this.$module.querySelector("[name='startdate']");
		this.$to = this.$module.querySelector("[name='enddate']");

		this.eventManager.on(this, events.search.SETTING_BROWSER_QUERY, this.onSetBrowserQuery.bind(this));
		this.eventManager.on(this, events.search.FACET_CLEAR_ALL, this.onClearAllFacets.bind(this));

		addListener(this.$module.querySelector(".date-filter button[type=submit]"), "click", this.onDateSearch.bind(this));

		super.init();
	}

	override onSetBrowserQuery() {
		this.$from.value = this.queryObject.queryData.startdate;
		this.$to.value = this.queryObject.queryData.enddate;

		this.setKeywordDirtyStatus();
	}

	override onClearAllFacets() {
		this.$from.value = "";
		this.$to.value = "";

		this.setKeywordDirtyStatus();
	}

	override setKeywordDirtyStatus() {
		if (this.queryObject.hasStartDate() || this.queryObject.hasEndDate()) {
			this.dirtyManager.setDirty(this.datesExtensionName);
		} else {
			this.dirtyManager.removeDirty(this.datesExtensionName);
		}
	}

	onDateSearch() {
		this.queryObject.queryData.startdate = this.$from.value;
		this.queryObject.queryData.enddate = this.$to.value;

		this.search();
	}
}
